(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit-panel"] && !Shopify.designMode) return;
  try {
    
  // On the three-across row an open box floats over the page, so it closes
  // the way a menu does: a click outside it, Escape, or opening the other.
  (() => {
    const wide = window.matchMedia('(min-width: 990px)');
    const openBoxes = () => document.querySelectorAll('.visit-panel__box[open]');

    document.addEventListener('click', (event) => {
      if (!wide.matches) return;
      for (const box of openBoxes()) {
        if (!box.contains(event.target)) box.removeAttribute('open');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !wide.matches) return;
      for (const box of openBoxes()) {
        box.removeAttribute('open');
        box.querySelector('summary')?.focus();
      }
    });

    document.addEventListener(
      'toggle',
      (event) => {
        const opened = event.target;
        if (!wide.matches || !opened.matches?.('.visit-panel__box') || !opened.open) return;
        for (const box of openBoxes()) {
          if (box !== opened) box.removeAttribute('open');
        }
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
